import React, { lazy, Suspense } from 'react';

const LazyOrderHistoryMco = lazy(() => import('./OrderHistoryMco'));

const OrderHistoryMco = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyOrderHistoryMco {...props} />
  </Suspense>
);

export default OrderHistoryMco;
